import React, { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router';
import debounce from '@mui/material/utils/debounce';
import { dispatchToParent, isEmbedded } from './util';
import { AppProviders } from './provider/AppProviders';
import { PricingRoute } from './views/pricing';
import { DiscountRoute } from './views/discount';
import { VendorProgramRoute } from './views/vendorprogram';
import { Home, HomeWrapper } from './views/home';
import { CustomerGroupsRoute } from './views/customerGroups';
import BidLifeCycleRoute from './views/bidLifeCycle';
import { UsersRoute } from './views/users';
import { ProductGroupsRoute } from './views/productGroups';
import { IngramProgramsRoute } from './views/ingramPrograms';
import { AcopMaintenanceRoute } from './views/acopMaintenance';
import BidManagementHub from './views/bidManagementHub';
import ViewSageTransactions from './views/Sage/ViewSageTransactions';
import AuditLogs from './views/auditLogs/AuditLogs';

function App() {
  useEffect(() => {
    /* istanbul ignore else - ResizeObserver not supported in jest  */
    if (!isEmbedded()) {
      return;
    } else {
      const observer = new ResizeObserver(
        debounce((entries) => {
          const entry = entries?.[0];
          if (!entry) return;
          const payload = {
            height: entry.contentRect.height,
            width: entry.contentRect.width,
          };
          dispatchToParent({ event: 'window-resize', payload });
        }, 250)
      );
      observer.observe(document.documentElement);
      return () => observer.disconnect();
    }
  }, []);

  return (
    <div className="App" data-testid="root">
      <AppProviders basename="/" envVars={process.env}>
        <Routes>
          <Route element={<HomeWrapper />} path="">
            <Route element={<Home />} path="" />
            <Route element={<CustomerGroupsRoute />} path="customer-groups/*" />
            <Route element={<ProductGroupsRoute />} path="product-groups/*" />
            <Route element={<PricingRoute />} path="pricing/*" />
            <Route element={<DiscountRoute />} path="discount/*" />
            <Route element={<VendorProgramRoute />} path="vendor-program/*" />
            <Route element={<IngramProgramsRoute />} path="ingram-program/*" />
            <Route element={<BidLifeCycleRoute />} path="bidlifecycle/*" />
            <Route
              element={<AcopMaintenanceRoute />}
              path="discount-management/*"
            />
            <Route element={<BidManagementHub />} path="bid-management-hub/*" />
            <Route element={<UsersRoute />} path="users/*" />
            <Route element={<Navigate replace to="/" />} path="*" />
            <Route
              element={<ViewSageTransactions />}
              path="view-sage-transactions/*"
            />
            <Route element={<AuditLogs />} path="audit-logs/*" />
          </Route>
        </Routes>
      </AppProviders>
    </div>
  );
}

export default App;
